__turbopack_context__.v({
  "item": "amm72a_item",
  "nav": "amm72a_nav",
  "navBtn": "amm72a_navBtn",
  "navBtnLeft": "amm72a_navBtnLeft",
  "navBtnRight": "amm72a_navBtnRight",
  "rail": "amm72a_rail",
  "viewport": "amm72a_viewport",
});
